import { ENV } from 'shared/ENV';

export const EXTERNAL_DATA_WATCHDUTY_ORGANIZATION_ID = 1;
const EXTERNAL_DATA_PUBLIC_TILESET_NAME = 'external_data_public';

export const getWatchdutyTileUrl = (
  name: string,
  params?: Record<string, string>,
): string => {
  const url = new URL(name, ENV.VITE_TILE_SERVER_URL);
  if (params) {
    url.search = new URLSearchParams(params).toString();
  }
  return url.toString();
};

export const getWatchdutyExternalDataPublicTileUrl = (
  organization_id: number,
  short_name: string,
): string => {
  return getWatchdutyTileUrl(EXTERNAL_DATA_PUBLIC_TILESET_NAME, {
    organization_id: organization_id.toString(),
    layer_short_name: short_name,
  });
};

export const getWatchdutyStaticTileUrl = (
  layerName: string,
  // @todo remove the domain param when removing 'use_alternate_static_tile_cache_domain' release flag
  domain: string = ENV.VITE_STATIC_TILE_CACHE_DOMAIN,
): string => {
  return `https://${domain}/maptiles/${layerName}/style.json`;
};
